<template>
  <a-button @click="visible = true" v-if="IsShwoBtn && typebtn !== 'text'" :type="typebtn">{{
    btnName
  }}</a-button>
  <a
    v-if="IsShwoBtn && typebtn == 'text'"
    href="javascript:void(0);"
    type="link"
    @click="visible = true"
    class="theme-color"
    style="color: #2f7bff"
  >
    {{ btnName }}
  </a>
  <a-modal
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    v-model:visible="visible"
    :width="750"
    :title="btnName"
    ok-text="确认"
    cancel-text="取消"
    @ok="uploadFilesFn"
  >
    <upload-file-table
      ref="attachRef"
      v-model:value="attachList"
      :allow-edit="true"
      :biz-type="bizType"
    ></upload-file-table>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, toRefs, computed } from "vue";
import { getCurrentUserId } from "@/utils";
import { BizFileService } from "@/core";
import { FileRecord } from "@/core/services/file-upload.interface";
import { message } from "ant-design-vue";
import { PaymentFlowService } from "../payment-flow-btn.service";
export default defineComponent({
  isGlobal: true,
  name: "FinishPaymentBtn",
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    bizFileType: {
      type: String,
      required: true,
    },
    typebtn: {
      type: String,
      default: "primary",
    },
    btnName: {
      type: String,
      default: "完成收款",
    },
    eventName: {
      type: String,
    },
    url: {
      type: String,
      default: "",
    },
    status: {
      type: String,
      default: "",
    },
    record: {
      type: Object,
      default: () => {},
    },
    externalBizType: {
      type: String,
      default: "",
    },
    externalIdKey: {
      type: String,
      default: "",
    },
    applyPaymentId:{
      type: String,
      default: undefined,
    },
    columnName:{
      type: String,
      default: undefined,
    },
  },
  emits: ["refresh"],
  setup(props, { attrs, slots, emit }) {
    const state = reactive({
      visible: false,
      attachList: [] as FileRecord[],
      currentUserId: getCurrentUserId(),
    });
    const { run } = BizFileService.useCreateApi();
    const { run: successRun } = PaymentFlowService.useInvoiceStatusChangeApi();
    const { run: successRunIds } = PaymentFlowService.useInvoiceStatusChangeApis();
    // console.log('props1111111', props);
    // console.log('stateid', state.currentUserId);
    
    
    const IsShwoBtn = computed(() => {
      if (props.record) {
        return (props.record.createBy === state.currentUserId  || props.record.finalReviewerFlag);
      }else {
        return false
      }
    });
    const uploadFilesFn = async () => {
      // console.log('props', props);
      if (props?.record?.selectBizType) { //对外付款单，如果
       await successRunIds(
          [],
          null,
          props.record.applyPaymentIds,
          //@ts-ignore
          props?.record?.selectBizType,
          'LEASEPAYMENT',
          "",
          props.status
        );
      }
      const files = state.attachList.map((item) => {
        item.bizId = props.bizId;
        item.bizType = props.bizType;
        return item;
      });
      const res = props?.record?.selectBizType? 
       await successRunIds(
        files,
        null,
        [props.bizId],
        props.bizType,
        props.bizFileType,
        "",
        props.status
      ) :await successRun(
        files,
        props.bizId,
        props.bizType,
        props.bizFileType,
        "",
        props.status
      );
      
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
        return;
      }
      if (props.externalBizType != "") {
        const res2 = await successRun(
          files,
          props.record[props.externalIdKey],
          props.externalBizType,
          "",
          "",
          props.status,
          props.columnName
        );
      }
      message.success(res.respDesc);
      emit("refresh", null);
      state.visible = false;
      state.attachList = [];
      emit("refresh");

    };

    return {
      ...toRefs(state),
      uploadFilesFn,
      IsShwoBtn,
    };
  },
});
</script>
